/**
 * Created by YYVZB on 2017/11/2.
 */
import store from "@/store/index";
export default class Api {
  setStorage(keys, val) {
    //设置缓存
    let values = val;
    if (typeof val == "object") {
      values = JSON.stringify(val);
    }
    sessionStorage.setItem(keys, values);
  }

  getStorage(keys) {
    //获取缓存
    if (!sessionStorage.getItem(keys)) {
      return null;
    }
    try {
      return JSON.parse(sessionStorage.getItem(keys));
    } catch (e) {
      return sessionStorage.getItem(keys);
    }
  }

  /*
   * 设置缓存与store
   * */
  setVuexStorage(data) {
    this.setStorage("wxUserInfo", data);
    store.dispatch("wxUserInfoAction", data);
  }

  /*
   * 微信中的不同内核
   * */
  kernel() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      return "wx";
    } else {
      if (/android/.test(ua)) {
        return "android";
      } else if (/iphone|ipad|ipod/.test(ua)) {
        return "ios";
      } else {
        return "pc";
      }
    }
  }

  /*
   * IOS内核
   * */
  ios() {
    let ua = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(ua)) return true;
    return false;
  }

  /*
   * kln userAgent
   * */
  isKln() {
    if (/kln_android/.test(navigator.userAgent)) {
      return "kln_android";
    } else if (/kln_ios/.test(navigator.userAgent)) {
      return "kln_ios";
    } else {
      return false;
    }
  }

  nativeEvent(names) {
    let appHeaderName = names;
    if (appHeaderName == "医学V视界") {
      appHeaderName = "学术天地";
    } else if (appHeaderName == "专区") {
      appHeaderName = "学术专区";
    }
    if (this.isKln() == "kln_ios") {
      window.webkit.messageHandlers.doSomething.postMessage({
        titleName: appHeaderName,
      });
    } else if (this.isKln() == "kln_android") {
      window.doSomething.titleName(appHeaderName);
    }
  }

  /*
   * 手机号验证
   * */
  regPhone(phone) {
    let phoneReg = /^(((1[3456789][0-9]{1})|(15[0-9]{1}))+\d{8})$/;
    if (phoneReg.test(phone)) {
      return true;
    } else {
      return false;
    }
  }

  /*
   * 添加query时判断 ？ 或者 &
   * */
  prefixQuery(argUrl) {
    // let formatUrl =  this.infoWxShareUrl()
    if (argUrl.split("?").length > 1) {
      return "&";
    } else {
      return "?";
    }
  }

  /*
   * 格式化微信分享后的URL 去除分享后微信添加的标识
   * */
  infoWxShareUrl() {
    let shareUrl = location.href;
    if (/\.html\?from\=/.test(shareUrl)) {
      let infoUrl = shareUrl.split("?")[1].split("#")[0];
      let formatReg = new RegExp(infoUrl);
      return shareUrl.replace(formatReg, "").replace(/\?/, "");
    } else {
      return shareUrl;
    }
  }

  /*
   * 初始化神测数据
   * */
  infoSC(storageObj) {
    if (!storageObj) {
      sa.identify("", true);
    } else {
      sa.identify(storageObj.id || storageObj.wxOpenId || "", true);
      try {
        sa.setOnceProfile({
          companyName: storageObj.companyName || "",
        });
        sa.setOnceProfile({
          duties: storageObj.duties || "",
        });
        sa.setOnceProfile({
          nickName: storageObj.nickName || "",
        });
        sa.setOnceProfile({
          department: storageObj.department || "",
        });
        sa.setOnceProfile({
          phone: storageObj.phone || "",
        });
        sa.setOnceProfile({
          address: storageObj.address || "",
        });
        sa.setOnceProfile({
          RegisterChannel: storageObj.registerChannel || "",
        });
        sa.setOnceProfile({
          fullName: storageObj.fullName || "",
        });
      } catch (err) {
        console.log("未获得用户缓存信息");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js